import { RouteConfig } from "vue-router";

const routes: RouteConfig = {
  path: "/",
  component: () => import("@/templates/App/index.vue"),
  children: [
    {
      path: "/",
      name: "users",
      component: () => import("@/views/App/Users/index.vue")
    },
    {
      path: "screening",
      name: "screening",
      component: () => import("@/views/App/Screening/index.vue")
    },
    {
      path: "create-account",
      name: "create-account",
      component: () => import("@/views/App/CreateAccount/index.vue")
    },
    {
      path: "view-user-app/:username",
      name: "view-user-app",
      component: () => import("@/views/App/ViewUserApp/index.vue")
    }
  ].map((route: RouteConfig) => {
    route.meta = {
      authRequired: true
    };

    return route;
  })
};

export default routes;
